import Base from './document_package_rule_select_base_controller';

export default class extends Base {
  static targets = [
    ...Base.targets,
    'search',
    'list',
    'selectAllRow',
    'lenderRow',
    'lenderCheckbox',
  ];

  filter(event) {
    this.filterRows(this.lenderRowTargets, event.target.value || '');
  }

  toggleLender(event) {
    if (!this.directionPicked()) return;
    const checkbox = event.currentTarget.querySelector('input[type="checkbox"]');
    this.setCheckboxChecked(checkbox, !checkbox?.checked);
  }

  toggleSelectAll() {
    if (!this.directionPicked()) return;

    const visibleRows = this.lenderRowTargets.filter((row) => !row.classList.contains('hidden'));
    const allSelected = visibleRows.every((row) => {
      const checkbox = row.querySelector('input[type="checkbox"]');
      return checkbox && checkbox.checked;
    });

    visibleRows.forEach((row) => {
      const checkbox = row.querySelector('input[type="checkbox"]');
      this.setCheckboxChecked(checkbox, !allSelected);
    });
  }
}
